
  
import { Vue, Component, Prop } from 'vue-property-decorator';
import { IModalComponent, Btn, Field, TextareaField, FormButtonDisabler } from '@samc/centricity-core';
import { DiligenceExceptionStatusDropdownField } from '@/Components/Dropdowns';
import { AjaxHelper, errToMessage, getToken } from '@samc/common';
import { IReviewDiligenceException } from '@/Interfaces';

@Component({
  name: 'review-ddexception-modal',
  components: { TextareaField, Btn, Field, FormButtonDisabler, DiligenceExceptionStatusDropdownField }
})
export default class ReviewDiligenceExceptionModal extends Vue implements IModalComponent {
  @Prop() public addCloseProp!: (callback: () => Promise<any>) => void;
  @Prop() public closeProp!: () => void;
  @Prop({ default: [] }) public exceptionIdList!: number[];
  @Prop() public verificationToken!: string;

  public ajaxHelper: AjaxHelper | null = null;

  public statusId: number = -1;
  public comments: string = '';
  public mitigatingFactors: string = '';
  public inprogress: boolean = false;

  public mounted() {
    this.ajaxHelper = new AjaxHelper('', this.verificationToken, null, getToken());
  }

  public async reviewExceptions() {
    try {
      this.validateInputs();

      if (this.warningMsg.length > 0)
      {
        this.$alert({
          title: 'Validation Failed',
          description: 'Please read below for details',
          type: 'error',
          errors: this.warningMsg.slice(0, 10)
        });

        this.warningMsg = [];
        return;
      }
      const request = { exceptionIdList: this.exceptionIdList, statusId: this.statusId, comments: this.comments, mitigatingFactors: this.mitigatingFactors } as IReviewDiligenceException;

      if (!request) return;

      this.$loading('Updating exceptions...');
      const response = await this.ajaxHelper?.postData<number>('componentapi/duediligence/reviewExceptions', request);

      this.$alert.success(`Successfully updated diligence exceptions for ${this.exceptionIdList.length} ` + (this.exceptionIdList.length > 1 ? 'loans' : 'loan') + '.');
      this.closeProp();
    } catch (err) {
        this.$log(err);
        this.$alert({
          type: 'error',
          title: `Failed to update diligence exceptions for selected ${this.exceptionIdList.length > 1 ? 'loans' : 'loan'}.`,
          description: 'For more detailed information, please contact support team.',
          errors: errToMessage(err),
          closingOption: 'holdOpen'
        });
      } finally {
        this.$loading();
        this.inprogress = false;
        this.warningMsg = [];
      }
  }

  private warningMsg: string[] = [];

  private validateInputs() {
    this.warningMsg = [];

    if (this.exceptionIdList.length === 0)
      this.warningMsg.push('Please select at least one diligence exception to update.');

    if (this.statusId === -1)
      this.warningMsg.push('A status must be selected.');
  }
}

